import request from '../helpers/request';

const addWarrantyDocs = async (requestId, values) => {
  const formData = new FormData();

  formData.append('file', values.file);
  formData.append('direction', values.direction);
  formData.append('docDate', values.docDate);
  formData.append('name', values.name);
  formData.append('orgId', values.orgId);
  formData.append('typeId', values.typeId);

  return await request.post(
    `/Warranty/docs/${requestId}`,
    formData,
    `При загрузке файлов произошла ошибка`
  );
};

export default addWarrantyDocs;
